export default __webpack_public_path__ + "static/media/img3.b3660022.jpg";